export class SearchTerm {
	curSearchTerm : string; 
}